import {Component, Mixins} from 'vue-property-decorator';
import CrudMixin from "@/mixins/CrudMixin";
import DataLoadCard from "@/componentsReusable/DataLoadCard.vue";
import {InputType} from "@/componentsReusable/InputType";
import InputAndError from "@/componentsReusable/InputAndError.vue";
import SingleItemUpdatePanel from "@/componentsReusable/SingleItemUpdatePanel.vue";
import {HTTP} from "@/utils/httpCommonUtil";
import {convertDateStringToUTCDate} from "@/utils/dateUtil";
import {MalpracticeInsurance} from "@/components/settings/cards/malpracticeinsurance/MalpracticeInsurance";

@Component({
  components: {
    DataLoadCard,
    SingleItemUpdatePanel,
    CrudMixin,
    InputAndError
  },
})
export default class MalpracticeInsurancePanel extends Mixins(CrudMixin) {

  protected entity: MalpracticeInsurance = {
    id: 0,
    currentCarrier: '',
    agency: '',
    contactName: '',
    address: '',
    city: '',
    stateId: null,
    zip: '',
    phone: '',
    fax: '',
    email: '',
    typeOfCoverage: '',
    policyNumber: '',
    effectiveOn: null,
    expireOn: null,
    perClaimAmount: 0,
    aggregateAmount: 0,
    isNew: false,
    isEditing: true,
    isUpdating: false
  };

  protected InputType = InputType;

  async getItems(): Promise<void> {
    this.loadingCounter++;
    try {
      const response = await HTTP.get(this.getFetchUrl());
      const item = response.data.data;
      item.isEditing = false;
      item.isUpdating = false;
      item.isNew = false;
      this.getFieldNames().forEach(fieldName => {
        item[fieldName + "ErrorMessage"] = '';
      });
      this.getStringDateFields().forEach(dateFieldName => {
        if (item[dateFieldName]) {
          item[dateFieldName] = convertDateStringToUTCDate(item[dateFieldName]);
        }
      });
      this.entity = item;
    } catch (error) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: `An error occurred getting ${this.entityName} data.`,
        duration: 5000
      });
    } finally {
      this.loadingCounter--;
    }
  }

  protected getFetchUrl(): string {
    return `/api/malpractice-insurance`;
  }

  protected getWriteUrl(): string {
    return `/api/malpractice-insurance`;
  }

  protected getFieldNames(): string[] {
    return [
      "currentCarrier",
      "agency",
      "contactName",
      "address",
      "city",
      "stateId",
      "zip",
      "phone",
      "fax",
      "email",
      "typeOfCoverage",
      "policyNumber",
      "effectiveOn",
      "expireOn",
      "perClaimAmount",
      "aggregateAmount"
    ]
  }

  protected getStringDateFields(): string[] {
    return [
      "effectiveOn",
      "expireOn"
    ]
  }

  protected getUniqueId(fieldName: string): string {
    return 'malpracticeInsurance-' + fieldName;
  }

}



// WEBPACK FOOTER //
// ./src/components/settings/cards/malpracticeinsurance/MalpracticeInsurancePanel.ts